import { API_CONFIG } from "../config/environment";

/**
 * Servicio para gestionar PendingChanges (4-eyes para Venta Directa Bienes).
 * Endpoints: /api/v2/bienes/pending-changes
 */

const createAuthHeaders = (token, additionalHeaders = {}) => {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...additionalHeaders,
  };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};

const handleResponse = async (response) => {
  if (response.status === 401 || response.status === 403) {
    const errorData = await response.json().catch(() => ({}));
    if (response.status === 401) {
      window.dispatchEvent(
        new CustomEvent("token-expired", {
          detail: { status: response.status },
        }),
      );
    }
    const err = new Error(errorData.error?.message || "No autorizado");
    err.code = errorData.error?.code;
    err.status = response.status;
    throw err;
  }
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const err = new Error(
      errorData.error?.message || `HTTP error! status: ${response.status}`,
    );
    err.code = errorData.error?.code;
    err.status = response.status;
    throw err;
  }
  return response.json();
};

const BASE = `${API_CONFIG.V2_BASE_URL}/bienes/pending-changes`;

export const pendingChangesService = {
  /**
   * @param {object} params - { entityType, entityId, status, requestedBy, page, limit }
   */
  list: async (params = {}, token) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== null && v !== undefined && v !== "") qs.append(k, String(v));
    });
    const res = await fetch(`${BASE}?${qs}`, {
      headers: createAuthHeaders(token),
    });
    return handleResponse(res);
  },

  getById: async (id, token) => {
    const res = await fetch(`${BASE}/${id}`, {
      headers: createAuthHeaders(token),
    });
    return handleResponse(res);
  },

  approve: async (id, notes, token, selectedFields = null) => {
    const res = await fetch(`${BASE}/${id}/approve`, {
      method: "POST",
      headers: createAuthHeaders(token),
      body: JSON.stringify({ notes, selectedFields }),
    });
    return handleResponse(res);
  },

  reject: async (id, notes, token) => {
    const res = await fetch(`${BASE}/${id}/reject`, {
      method: "POST",
      headers: createAuthHeaders(token),
      body: JSON.stringify({ notes }),
    });
    return handleResponse(res);
  },

  cancel: async (id, token) => {
    const res = await fetch(`${BASE}/${id}`, {
      method: "DELETE",
      headers: createAuthHeaders(token),
    });
    return handleResponse(res);
  },
};

export default pendingChangesService;
